export const VIEWER_SERVICE_EXTENSION_NAME = 'VIEWER_SERVICE'
